import FileSaver from 'file-saver';

declare type AxiosResponse = {
  data: any
  headers: Array<[string, any]>
}

export function AxiosSaveContentToFile(defaultFileName: string, response: AxiosResponse): void {
  const contentType: string = response.headers['content-type'] || '';

  const boundaryMatch = contentType.match(/boundary="([^"]+)"/);
  const boundary = (boundaryMatch?.length > 1) ? boundaryMatch[1] : null;

  if (boundary != null) {
    const parts: string[] = response
      .data
      .split(`--${boundary}`)
      .filter(s => !(s == null || s.length === 0 || s.startsWith('--')));
    for (let part of parts) {
      const [partHeader, fileName] =
        part.match(/\r?\nContent-Disposition: attachment; filename="([^"]+)";.*\r?\n\r?\n/) || [];
      if (partHeader != null && fileName != null) {
        FileSaver.saveAs(new Blob([part.substring(partHeader.length)]), fileName);
      }
    }
    return;
  }

  let fileName = defaultFileName;
  const contentDispositionHeader = response.headers['Content-Disposition'];
  if (contentDispositionHeader) {
    const startFileNameIndex: number = contentDispositionHeader.indexOf('"') + 1;
    const endFileNameIndex: number = contentDispositionHeader.lastIndexOf('"');
    const providedFileName: number = contentDispositionHeader.substring(startFileNameIndex, endFileNameIndex);
    if (providedFileName != null) {
      fileName = `${providedFileName}.ODF`;
    }
  }
  FileSaver.saveAs(new Blob([response.data]), fileName);
}
